export const isCustomTeamSizesBrandKitEnabled = (): boolean =>
  process.env.REACT_APP_CUSTOM_TEAM_SIZES_BRAND_KIT_ENABLED === "true";

export const isCustomTeamSizesCategoriesEnabled = (): boolean =>
  process.env.REACT_APP_CUSTOM_TEAM_SIZES_CATEGORIES_ENABLED === "true";
